import React from "react";
import ReactDOM from "react-dom/client";
import AppBridgeProvider from "./components/AppBridgeProvider.jsx";
import App from "./App.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AppBridgeProvider>
      <App />
    </AppBridgeProvider>
  </React.StrictMode>
);
